<template>
    <v-container>
        <div v-if="showcargando == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row>
            <v-card width="100%" class="mx-1">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-card class="text-xs-center ma-1">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">{{ title }} Reporte</span>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col cols="12" md="12">
                                    <span>Nombre del Procedimiento: </span>
                                    <v-text-field v-model="procedimiento" outlined autofocus dense
                                        :rules="[rules.required]">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Periodicidad:</v-list-item-title>
                                            <v-radio-group v-model="periodo" class="ml-6" v-on:change="Cambio()"
                                                :rules="[v => !!v || 'Opción requerida']" column>
                                                <v-radio label="Anual" color="primary" value="1"></v-radio>
                                                <v-radio label="Mensual" color="primary" value="2"></v-radio>
                                                <v-radio label="Diario" color="primary" value="3"></v-radio>
                                                <v-radio label="Días específicos" color="primary" value="4"></v-radio>
                                                <v-radio label="Hora" v-if="ra == 2" color="primary"
                                                    value="5"></v-radio>
                                                <v-radio label="Minutos" v-if="ra == 2" color="primary"
                                                    value="6"></v-radio>
                                            </v-radio-group>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div v-if="periodo == 1">
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Día del mes:</v-list-item-title>
                                                <v-text-field v-model="diames"
                                                    :rules="periodo == 1 ? [rules.required] : []" outlined dense
                                                    @keypress="filter($event)">
                                                </v-text-field>
                                                <span v-if="validadiames" class='spanError'
                                                    style="color:red;font-size:11px">
                                                    {{ errordia }}
                                                </span>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Mes:</v-list-item-title>
                                                <v-select :items="Meses"
                                                    :rules="periodo == 1 ? [v => !!v || 'Opción requerida'] : []"
                                                    required v-model="mes" label="Mes" item-text="msnombre"
                                                    item-value="msclave" dense solo></v-select>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Hora(24 hrs.):</v-list-item-title>
                                                <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false"
                                                    :nudge-right="40" :return-value.sync="hora"
                                                    transition="scale-transition" offset-y max-width="290px"
                                                    min-width="290px">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field v-model="hora"
                                                            :rules="periodo == 1 ? [rules.required] : []" dense readonly
                                                            outlined v-bind="attrs" v-on="on"></v-text-field>
                                                    </template>
                                                    <v-time-picker v-if="menu3" v-model="hora" format="24hr" full-width
                                                        @click:minute="$refs.menu3.save(hora)"></v-time-picker>
                                                </v-menu>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </div>
                                    <div v-if="periodo == 2">
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Día del mes:</v-list-item-title>
                                                <v-text-field v-model="diames"
                                                    :rules="periodo == 2 ? [rules.required, rules.dias] : []" outlined
                                                    @keypress="filter($event)" dense>
                                                </v-text-field>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Hora(24 hrs.):</v-list-item-title>
                                                <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false"
                                                    :nudge-right="40" :return-value.sync="hora"
                                                    transition="scale-transition" offset-y max-width="290px"
                                                    min-width="290px">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field v-model="hora"
                                                            :rules="periodo == 2 ? [rules.required] : []" dense readonly
                                                            outlined v-bind="attrs" v-on="on"></v-text-field>
                                                    </template>
                                                    <v-time-picker v-if="menu3" v-model="hora" format="24hr" full-width
                                                        @click:minute="$refs.menu3.save(hora)"></v-time-picker>
                                                </v-menu>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </div>
                                    <div v-if="periodo == 3">
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Hora(24 hrs.):</v-list-item-title>
                                                <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false"
                                                    :nudge-right="40" :return-value.sync="hora"
                                                    transition="scale-transition" offset-y max-width="290px"
                                                    min-width="290px">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field v-model="hora"
                                                            :rules="periodo == 3 ? [rules.required] : []" dense readonly
                                                            outlined v-bind="attrs" v-on="on"></v-text-field>
                                                    </template>
                                                    <v-time-picker v-if="menu3" v-model="hora" format="24hr" full-width
                                                        @click:minute="$refs.menu3.save(hora)"></v-time-picker>
                                                </v-menu>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </div>
                                    <div v-if="periodo == 4">
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Días:</v-list-item-title>
                                                <v-checkbox v-model="lunes" label="Domingo"></v-checkbox>
                                                <v-checkbox v-model="martes" label="Lunes"></v-checkbox>
                                                <v-checkbox v-model="miercoles" label="Martes"></v-checkbox>
                                                <v-checkbox v-model="jueves" label="Miércoles"></v-checkbox>
                                                <v-checkbox v-model="viernes" label="Jueves"></v-checkbox>
                                                <v-checkbox v-model="sabado" label="Viernes"></v-checkbox>
                                                <v-checkbox v-model="domingo" label="Sábado"></v-checkbox>
                                                <span style="color: red;" v-show="validadias">Selección requerida</span>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Hora(24 hrs.):</v-list-item-title>
                                                <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false"
                                                    :nudge-right="40" :return-value.sync="hora"
                                                    transition="scale-transition" offset-y max-width="290px"
                                                    min-width="290px">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field v-model="hora"
                                                            :rules="periodo == 4 ? [rules.required] : []" dense readonly
                                                            outlined v-bind="attrs" v-on="on"></v-text-field>
                                                    </template>
                                                    <v-time-picker v-if="menu3" v-model="hora" format="24hr" full-width
                                                        @click:minute="$refs.menu3.save(hora)"></v-time-picker>
                                                </v-menu>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </div>
                                    <div v-if="periodo == 5">
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Hora(24 hrs.):</v-list-item-title>
                                                <v-text-field v-model="hora"
                                                    :rules="periodo == 5 ? [rules.required, rules.hora] : []"
                                                    @keypress="filter($event)" outlined dense
                                                    v-on:blur="hora = hora.trim()"></v-text-field>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </div>
                                    <div v-if="periodo == 6">
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Minutos:</v-list-item-title>
                                                <v-text-field v-model="minutos"
                                                    :rules="periodo == 6 ? [rules.required, rules.minuto] : []" outlined
                                                    @keypress="filter($event)" dense
                                                    v-on:blur="minutos = minutos.trim()">
                                                </v-text-field>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Reporte automático:</v-list-item-title>
                                            <v-radio-group v-model="ra" class="ml-6">
                                                <v-radio color="primary" value="1"></v-radio>
                                            </v-radio-group>
                                            <span v-if="tipore" style="color: #ff4081;" id="selectError"> Debe
                                                seleccionar el tipo de reporte </span>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Fecha Inicio:</v-list-item-title>
                                            <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                                                transition="scale-transition" offset-y max-width="290px"
                                                min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="fecha" outlined readonly
                                                        :rules="[rules.required]" v-bind="attrs"
                                                        @blur="date = parseDate(fecha)" dense v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="date" locale="es-mx" :min="minfecha"
                                                    @input="menu1 = false"></v-date-picker>
                                            </v-menu>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Descripción:</v-list-item-title>
                                            <v-text-field v-model="descripcion" counter="100" maxlenght="100"
                                                :rules="[rules.required, rules.counter, rules.text]" outlined dense
                                                v-on:blur="descripcion = descripcion.trim()">
                                            </v-text-field>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <div v-if="ra == 1">
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Para:</v-list-item-title>
                                                <v-text-field v-model="para"
                                                    :rules="para != '' && ra == 1 ? [rules.required, rules.email] : []"
                                                    outlined dense
                                                    title="Escriba el correo válido y oprima el botón agregar"
                                                    v-on:blur="para = para.trim()">
                                                    <template v-slot:append-outer>
                                                        <v-btn style="top: -8px" @click="Agregar(para, 1)"
                                                            :disabled="disabledp">Agregar</v-btn>
                                                    </template>
                                                </v-text-field>

                                                <div v-for="(item, i) in paras">
                                                    <v-chip close @click:close="paras.splice(i, 1)">
                                                        {{ item.text }}
                                                    </v-chip>
                                                </div>
                                                <span v-if="validacorreo" class='spanError'
                                                    style="color:red;font-size:11px">
                                                    Tiene que agregar correo valido
                                                </span>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Con copia oculta:</v-list-item-title>
                                                <v-text-field v-model="cco"
                                                    :rules="cco != '' && ra == 1 ? [rules.email] : []" outlined dense
                                                    title="Escriba el correo válido y oprima el botón agregar"
                                                    v-on:blur="cco = cco.trim()">
                                                    <template v-slot:append-outer>
                                                        <v-btn style="top: -8px" @click="Agregar(cco, 3)"
                                                            :disabled="disabledcco">Agregar</v-btn>
                                                    </template>
                                                </v-text-field>

                                                <div v-for="(item, i) in ccos">
                                                    <v-chip close @click:close="ccos.splice(i, 1)">
                                                        {{ item.text }}
                                                    </v-chip>
                                                </div>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Trabajo:</v-list-item-title>
                                            <v-radio-group v-model="ra" class="ml-6">
                                                <v-radio color="primary" label="" value="2"></v-radio>
                                            </v-radio-group>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Fecha Termino:</v-list-item-title>
                                            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                                                transition="scale-transition" offset-y max-width="290px"
                                                min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="fechater" outlined readonly v-bind="attrs"
                                                        @blur="date2 = parseDate(fechater)" dense
                                                        v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="date2" locale="es-mx" :min="minfecha"
                                                    @input="menu2 = false"></v-date-picker>
                                            </v-menu>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title>Única vez:</v-list-item-title>
                                            <v-radio-group v-model="unicavez" class="ml-6">
                                                <v-radio color="primary" value="1"></v-radio>
                                                <!--<v-radio color="primary"
                                                         value="0"></v-radio>-->
                                            </v-radio-group>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <div v-if="ra == 1">
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>Con copia:</v-list-item-title>
                                                <v-text-field v-model="cc"
                                                    :rules="cc != '' && ra == 1 ? [rules.email] : []" outlined dense
                                                    title="Escriba el correo válido y oprima el botón agregar"
                                                    v-on:blur="cc = cc.trim()">
                                                    <template v-slot:append-outer>
                                                        <v-btn style="top: -8px" @click="Agregar(cc, 2)"
                                                            :disabled="disabledcc">Agregar</v-btn>
                                                    </template>
                                                </v-text-field>

                                                <div v-for="(item, i) in ccs">
                                                    <v-chip close @click:close="ccs.splice(i, 1)">
                                                        {{ item.text }}
                                                    </v-chip>
                                                </div>
                                                <span v-if="validacco" class='spanError'
                                                    style="color:red;font-size:11px">
                                                    Tiene que agregar correo valido
                                                </span>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </div>

                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="text-center">
                                    <v-btn class="ma-2" @click="Guardar()" color="primary">
                                        Guardar
                                        <template v-slot:loader>
                                            <span>Loading...</span>
                                        </template>
                                    </v-btn>
                                    <v-btn class="ma-2" @click="Limpiar()" v-if="shid == 0" color="default">
                                        Limpiar
                                    </v-btn>
                                    <v-btn class="ma-2" @click="Cancelar()" color="error">
                                        Cancelar
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import moment from "moment";
import { mapGetters, mapState, mapMutations } from 'vuex';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Sistemas from "@/services/Sistemas/sistemas.service.js";
import Menu from '@/components/pages/Sistemas/MenuSistemas.vue';

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        Menu,
    },
    data() {
        return {
            valid: true,
            validadias: false,
            menu1: false,
            menu2: false,
            menu3: false,
            fecha: '',
            validadiames: false,
            errordia: '',
            date: moment().format("YYYY[-]MM[-]DD"),
            date2: moment().format("YYYY[-]MM[-]DD"),
            minfecha: moment().format("YYYY[-]MM[-]DD"),
            showcargando: true,
            procedimiento: '',
            periodo: 0,
            Meses: [
                { msclave: 1, msnombre: 'Enero' },
                { msclave: 2, msnombre: 'Febrero' },
                { msclave: 3, msnombre: 'Marzo' },
                { msclave: 4, msnombre: 'Abril' },
                { msclave: 5, msnombre: 'Mayo' },
                { msclave: 6, msnombre: 'Junio' },
                { msclave: 7, msnombre: 'Julio' },
                { msclave: 8, msnombre: 'Agosto' },
                { msclave: 9, msnombre: 'Septiembre' },
                { msclave: 10, msnombre: 'Octubre' },
                { msclave: 11, msnombre: 'Noviembre' },
                { msclave: 12, msnombre: 'Diciembre' },
            ],
            mes: null,
            diames: '',
            cc: '',
            ccs: [],
            unicavez: 0,
            fechater: '',
            cco: '',
            ccos: [],
            ra: null,
            descripcion: '',
            para: '',
            paras: [],
            hora: '',
            minutos: '',
            dia: 0,
            rules: {
                required: value => !!value || 'Campo requerido',
                counter: value => {
                    if (value == null || value == '') {
                        return true
                    }
                    else {
                        return value.length >= 6 || 'Minino 6 caracteres'
                    }
                }
                ,
                text: value => {
                    if (value == null || value == '') {
                        return true
                    }
                    else {
                        return value.length <= 100 || 'Máximo 100 caracteres'
                    }
                },
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Correo invalido'
                },
                dias: value => value >= 1 && value <= 29 || 'El día debe ser mayor 0 ó menor a 29',
                minuto: value => value >= 1 || 'Los minutos deben ser mayores a cero',
                hora: value => value >= 1 || 'Las horas deben ser mayores a cero',
            },
            lunes: false,
            martes: false,
            miercoles: false,
            jueves: false,
            viernes: false,
            sabado: false,
            domingo: false,
            vdias: 0,
            dias: '',
            datos: '',
            shid: 0,
            tipore: false,
            validacorreo: false,
            validacc: false,
            validacco: false,
            disabledp: true,
            disabledcco: true,
            disabledcc: true,
            title: 'Alta',
            user: '',
        }
    },
    computed: {
        ...mapState(['permission', 'domain']),
        ...mapGetters(['getUser', 'THEME_STATE'])
    },
    methods: {
        Agregar(correo, tipo) {
            if (correo != '') {
                if (tipo == 1) {
                    let indice = this.paras.findIndex((obj => obj.text === correo));
                    if (indice == -1) {
                        this.paras.push({
                            text: correo
                        });

                    }
                    this.para = '';
                    this.disabledp = true;
                    this.validacorreo = false;
                }

                if (tipo == 2) {
                    let indice = this.ccs.findIndex((obj => obj.text === correo));
                    if (indice == -1) {
                        this.ccs.push({
                            text: correo
                        });

                    }
                    this.cc = '';
                    this.disabledcc = true;
                    this.validacc = false;
                }

                if (tipo == 3) {
                    let indice = this.ccos.findIndex((obj => obj.text === correo));
                    if (indice == -1) {
                        this.ccos.push({
                            text: correo
                        });

                    }
                    this.cco = '';
                    this.disabledcco = true;
                    this.validacco = false;
                }
            }
            else {
                this.$swal(
                    "Atención",
                    "Tiene que agregar correo valido",
                    "info"
                );
            }
        },
        Limpiar() {
            this.showcargando = true;
            this.$refs.form.reset();
            this.date = moment().format("YYYY[-]MM[-]DD");
            this.date2 = moment().format("YYYY[-]MM[-]DD");
            this.descripcion = '';
            this.procedimiento = '';
            this.tipore = false;
            this.paras = [];
            this.ccs = [];
            this.ccos = [];
            setTimeout(() => {
                this.fechater = '';
                this.showcargando = false;
            }, 1000);
        },
        Cancelar() {
            this.$router.push({ name: 'Listado' });
        },
        async ValidarProce() {
            let ban = false;
            if (this.procedimiento != '') {
                if (this.procedimiento.length > 0)
                    this.procedimiento = this.procedimiento.trim()
                let formdata = new FormData();
                formdata.append("sp", this.procedimiento);
                await Sistemas.ExisteProcedimiento(formdata).then(data => {
                    ban = data;
                    if (!data) {
                        this.$swal({
                            position: "center",
                            icon: "info",
                            title: "Atención!",
                            text: "El procedimiento no existe",
                            confirmButtonText: "Aceptar",
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            timer: 4000,
                        });
                    }
                });
            }
            return ban;
        },
        Cambio() {
            this.diames = null;
            this.menu3 = false;
            this.mes = {};
            this.lunes = false;
            this.martes = false;
            this.miercoles = false;
            this.jueves = false;
            this.viernes = false;
            this.sabado = false;
            this.domingo = false;
            this.validadiames = false;
        },
        validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        UnificarCorreo(correo) {
            let email = ''
            for (var i = 0; i < correo.length; i++) {
                if (i == correo.length - 1) {
                    email += correo[i].text;
                }
                else
                    email += correo[i].text + ',';
            }

            return email;
        },
        async Guardar() {
            let vd = true, vcorreo = true, banproce = false;
            let mensaje = '';
            if (this.periodo == 4 && this.vdias == 0) {
                vd = false;
                this.validadias = true;
            }

            banproce = await this.ValidarProce();
            if (this.ra == 1)
                vcorreo = this.paras.length > 0 ? true : false;
            this.validacorreo = !vcorreo;
            if (this.ra == null) {
                this.tipore = true;
            }

            let date = new Date();
            if (this.mes > 0) {
                if (this.diames > new Date(date.getFullYear(), this.mes, 0).getDate() || this.diames < 1) {
                    this.validadiames = true;
                    this.errordia = 'El día debe ser mayor 0 o menor a ' + new Date(date.getFullYear(), this.mes, 0).getDate();
                }
                else {
                    this.validadiames = false;
                }
            }

            if (this.$refs.form.validate() && vd == true && vcorreo == true && banproce == true && this.ra != null && this.validadiames == false) {
                let pp = this.UnificarCorreo(this.paras);
                let cc = this.UnificarCorreo(this.ccs);
                let cco = this.UnificarCorreo(this.ccos);

                let formdata = new FormData();
                formdata.append("uslogin", this.user);
                formdata.append("sp", this.procedimiento);
                formdata.append("id", this.shid);
                if (this.periodo == 1) {
                    formdata.append("mes", this.mes);
                    formdata.append("dia", this.diames);
                }
                else if (this.periodo == 2) {
                    formdata.append("dia", this.diames);
                }
                else if (this.periodo == 3) {
                    formdata.append("diario", true);
                }
                else if (this.periodo == 4) {
                    this.dias += this.lunes ? '1' : '0';
                    this.dias += this.martes ? '1' : '0';
                    this.dias += this.miercoles ? '1' : '0';
                    this.dias += this.jueves ? '1' : '0';
                    this.dias += this.viernes ? '1' : '0';
                    this.dias += this.sabado ? '1' : '0';
                    this.dias += this.domingo ? '1' : '0';

                    formdata.append("dias", this.dias);
                }

                formdata.append("fechaInicial", this.date);
                if (this.fechater != '')
                    formdata.append("fechaFinal", this.date2);
                formdata.append("descripcion", this.descripcion);
                formdata.append("unica", this.unicavez == 1 ? true : false);
                formdata.append("tipo", this.ra == 1 ? 'RA' : 'JOB');
                formdata.append("to", pp);
                formdata.append("cc", cc);

                formdata.append("cco", cco);
                if (this.periodo == 5)
                    formdata.append("horasJob", this.hora);
                if (this.periodo == 6)
                    formdata.append("minutosJob", this.minutos);
                if (this.periodo != 5 && this.periodo != 6) {
                    let data = this.hora.split(":");
                    formdata.append("hra", data[0]);
                    formdata.append("min", data[1]);
                }

                if (this.shid > 0)
                    mensaje = "Se guardó de manera exitosa el reporte automático.";
                else
                    mensaje = "Se guardó de manera exitosa el reporte automático.";
                this.$swal({
                    position: "center",
                    title: "Procesando Guardando...",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirm: false,
                });
                this.$swal.showLoading();
                await Sistemas.GuardarReporte(formdata).then(data => {
                    if (data) {
                        this.$swal({
                            position: "center",
                            icon: "success",
                            title: "Éxito!",
                            text: mensaje,
                            confirmButtonText: "Aceptar",
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            timer: 4000,
                        }).then((result) => {
                            this.$router.push({ name: 'Listado' });
                        });
                    }
                    else {
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: "Error!",
                            html: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                            confirmButtonText: "Aceptar",
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            timer: 4000,
                        }).then((result) => {

                        });
                    }
                });
            }
        },
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        filter: function (evt) {
            evt = (evt) ? evt : window.event;
            let expect = evt.target.value.toString() + evt.key.toString();

            if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
    },
    watch: {
        'diames'(val) {
            let date = new Date();
            if (this.mes > 0) {
                if (this.diames > new Date(date.getFullYear(), this.mes, 0).getDate() || this.diames < 1) {
                    this.validadiames = true;
                    this.errordia = 'El día debe ser mayor 0 o menor a ' + new Date(date.getFullYear(), this.mes, 0).getDate();
                }
                else {
                    this.validadiames = false;
                }
            }
        },
        'para'(val) {
            if (this.validateEmail(this.para)) {
                this.disabledp = false;
            }
        },
        'cc'(val) {
            if (this.validateEmail(this.cc)) {
                this.disabledcc = false;
            }
        },
        'cco'(val) {
            if (this.validateEmail(this.cco)) {
                this.disabledcco = false;
            }
        },
        'ra'(val) {
            if (this.ra == null) {
            }
            else {
                this.tipore = false;
            }
        },
        date(val) {
            this.fecha = this.formatDate(this.date);
        },
        date2(val) {

            this.fechater = this.formatDate(this.date2);
        },
        lunes() {
            if (this.lunes) {
                this.vdias++;
                this.validadias = false;
            }
            else {
                this.vdias--;
            }
        },
        martes() {
            if (this.martes) {
                this.vdias++;
                this.validadias = false;
            }
            else {
                this.vdias--;
            }
        },
        miercoles() {
            if (this.miercoles) {
                this.vdias++;
                this.validadias = false;
            }
            else {
                this.vdias--;
            }
        },
        jueves() {
            if (this.jueves) {
                this.vdias++;
                this.validadias = false;
            }
            else {
                this.vdias--;
            }
        },
        viernes() {
            if (this.viernes) {
                this.vdias++;
                this.validadias = false;
            }
            else {
                this.vdias--;
            }
        },
        sabado() {
            if (this.sabado) {
                this.vdias++;
                this.validadias = false;
            }
            else {
                this.vdias--;
            }
        },
        domingo() {
            if (this.domingo) {
                this.vdias++;
                this.validadias = false;
            }
            else {
                this.vdias--;
            }
        },
    },
    async mounted() {
        this.user = await MetodosGenerales.ObtenerUserName();
        if (window.sessionStorage.getItem("Tarea") != undefined) {
            this.datos = await MetodosGenerales.obtenerSessionReporte("Tarea");
            this.shid = this.datos.shclave;
            if (this.shid > 0)
                this.title = 'Editar';
            let formdata = new FormData();
            formdata.append("shclave", this.datos.shclave);
            await Sistemas.ObtenerDatos(formdata).then(data => {
                if (data.success) {
                    this.procedimiento = data.data.shsp;
                    if (data.data.shtipo == 'RA')
                        this.ra = "1";
                    else
                        this.ra = "2";
                    this.descripcion = data.data.shdescripcion;

                    this.unicavez = data.data.shunica == null || data.data.shunica == false ? "0" : "1";
                    this.date = data.data.shfhinicio.substring(0, 10);
                    this.date2 = data.data.shfhfin != null ? data.data.shfhfin.substring(0, 10) : '';
                    this.fecha = this.formatDate(this.date);
                    this.fechater = this.formatDate(this.date2);
                    if (data.data.shanio != null) {
                        this.periodo = "1";
                        this.diames = data.data.shmes;
                        this.hora = data.data.shhora + ':' + (data.data.shminuto < 10 ? '0' + data.data.shminuto : data.data.shminuto);
                        this.mes = data.data.shanio;
                    }
                    else if (data.data.shmes != null) {
                        this.periodo = "2";
                        this.diames = data.data.shmes;
                        this.hora = data.data.shhora + ':' + (data.data.shminuto < 10 ? '0' + data.data.shminuto : data.data.shminuto);
                    }
                    else if (data.data.shdiario == true) {
                        this.periodo = "3";
                        this.hora = data.data.shhora + ':' + (data.data.shminuto < 10 ? '0' + data.data.shminuto : data.data.shminuto);
                    }
                    else if (data.data.shdias != "") {
                        this.periodo = "4";
                        this.hora = data.data.shhora + ':' + (data.data.shminuto < 10 ? '0' + data.data.shminuto : data.data.shminuto);
                        if (data.data.shdias.charAt(0) == '1')
                            this.lunes = true;
                        if (data.data.shdias.charAt(1) == '1')
                            this.martes = true;
                        if (data.data.shdias.charAt(2) == '1')
                            this.miercoles = true;
                        if (data.data.shdias.charAt(3) == '1')
                            this.jueves = true;
                        if (data.data.shdias.charAt(4) == '1')
                            this.viernes = true;
                        if (data.data.shdias.charAt(5) == '1')
                            this.sabado = true;
                        if (data.data.shdias.charAt(6) == '1')
                            this.domingo = true;
                    }
                    else if (data.data.shhorajob != null) {
                        this.periodo = "5";
                        this.hora = data.data.shhorajob;
                    }
                    else if (data.data.shminutojob != null) {
                        this.periodo = "6";
                        this.minutos = data.data.shminutojob;
                    }
                }
            });
            await Sistemas.ObtenerCorreos(formdata).then(data => {
                if (data.data.TO != null) {
                    let datas = data.data.TO.split(",");
                    for (var i = 0; i < datas.length; i++) {
                        this.paras.push({
                            text: datas[i]
                        });
                    }

                }
                if (data.data.CC != null) {
                    let datas = data.data.CC.split(",");
                    for (var i = 0; i < datas.length; i++) {
                        this.ccs.push({
                            text: datas[i]
                        });
                    }
                }
                if (data.data.CCO != null) {
                    let datas = data.data.CCO.split(",");
                    for (var i = 0; i < datas.length; i++) {
                        this.ccos.push({
                            text: datas[i]
                        });
                    }
                }
            });


        }
        else {
            await Sistemas.ObtenerHora().then(data => {
                if (data.success) {
                    let minuto = data.data[0].shminuto < 10 ? '0' + data.data[0].shminuto : data.data[0].shminuto;
                    this.hora = data.data[0].shhora + ":" + minuto;
                }
                else {
                    this.hora = '00:00';
                }
            });
        }
        this.showcargando = false;
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '60').then(response => {
            if (response.data.length > 0) {
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }

        });
    }
}
</script>